import KmForm from './main.vue'
KmForm.install = function (vue) {
  vue.component(KmForm.name, KmForm)
}
export default KmForm



// WEBPACK FOOTER //
// ./src/ui/components/form/index.js